export default "__VITE_ASSET__dcab6599__"